// Auto-generated by scripts/inject-version.ts — do not edit.
export const SDK_VERSION = '0.1.2-next.1';
//# sourceMappingURL=version.js.map